import { ProductDiscountsOverview } from "./ProductDiscountsOverview"
import { PageContent } from "../../PageContent"
import { Heading, Stack } from "@chakra-ui/react"
import { Product } from "BrokerTsLib/src/enums"

export const DiscountsOverview = () => {
    return <PageContent>
        <Heading>Přehled slev</Heading>

        <Stack>
            <ProductDiscountsOverview product={Product.PropertyInsurance} name="Pojištění majetku a odpovědnosti" />
            <ProductDiscountsOverview product={Product.VehicleInsurance} name="Pojištění motorových vozidel" />
            <ProductDiscountsOverview product={Product.TravelInsurance} name="Cestovní pojištění" />
        </Stack>
    </PageContent>
}
